import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const inventoryUnitsMovedWidget: DashboardWidgetConfiguration = {
  widgetId: "inventory.units-moved",
  name: "Units moved",
  description: "Units moved for the selected dashboard period.",
  apps: [
    "home",
    "inventory",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.stock-events",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "quantity",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Units moved",
    subtext: "in the last 30 days",
    icon: "briefcase",
    color: "success",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 1450,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
